import { instanceCreated } from '@/common/analytics/Avo';
import { readStoredLoopId } from '@/common/utils/loop/selectLoop';

interface TrackInstanceCreatedParams {
  integrationInstanceUrl: string;
  integrationInstanceId: string;
  loopId?: number;
}

export const trackInstanceCreated = ({
  integrationInstanceUrl,
  integrationInstanceId,
  loopId,
}: TrackInstanceCreatedParams) => {
  const resolvedLoopId = loopId ?? readStoredLoopId();
  instanceCreated({
    integrationInstanceUrl,
    integrationInstanceId,
    loopId: resolvedLoopId !== undefined ? String(resolvedLoopId) : null,
  });
};
